// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SSote","type":"styles_type__1-TwX","choices":"styles_choices__2jGLl"};